import { render, staticRenderFns } from "./selectCourse.vue?vue&type=template&id=b3be5a4c&scoped=true&"
import script from "./selectCourse.vue?vue&type=script&lang=js&"
export * from "./selectCourse.vue?vue&type=script&lang=js&"
import style0 from "./selectCourse.vue?vue&type=style&index=0&id=b3be5a4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3be5a4c",
  null
  
)

export default component.exports